import { HEATING_OIL, LANDSCAPING, NATURAL_GAS, SEPARATE_HEATING_CHARGE, SNOW_REMOVAL } from '../../../constants/index';
import type { Section } from '../../../models/index';
import type { SwitchObject } from '../../../models/Types';
import SwitchesWithTitle from '../../Widgets/SwitchesWithTitle';

type Props = {
  section: Section;
  setSectionValues(keyValuePairs: object): void;
};

export default function Services_v1({ section, setSectionValues }: Props) {
  function toggleSwitch(key: string) {
    setSectionValues({
      [key]: !section.getFieldValue(key),
    });
  }

  function onLandscapingToggle() {
    toggleSwitch(LANDSCAPING.FIELD_NAME.IS_ENABLED);
  }

  function onSnowRemovalToggle() {
    toggleSwitch(SNOW_REMOVAL.FIELD_NAME.IS_ENABLED);
  }

  function onHeatingOilToggle() {
    toggleSwitch(HEATING_OIL.FIELD_NAME.IS_ENABLED);
  }

  function onNaturalGasToggle() {
    toggleSwitch(NATURAL_GAS.FIELD_NAME.IS_ENABLED);
  }

  function onSeparateHeatingChargeToggle() {
    toggleSwitch(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED);
  }

  const services: Array<SwitchObject> = [
    {
      text: 'Natural gas',
      onClick: onNaturalGasToggle,
      toggled: section.getFieldValue(NATURAL_GAS.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Heating oil',
      onClick: onHeatingOilToggle,
      toggled: section.getFieldValue(HEATING_OIL.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Heating charge (if separate from other utilities)',
      onClick: onSeparateHeatingChargeToggle,
      toggled: section.getFieldValue(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Landscaping',
      onClick: onLandscapingToggle,
      toggled: section.getFieldValue(LANDSCAPING.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Snow removal',
      onClick: onSnowRemovalToggle,
      toggled: section.getFieldValue(SNOW_REMOVAL.FIELD_NAME.IS_ENABLED),
    },
  ];

  return (
    <div className="stacked-children-md">
      <SwitchesWithTitle
        switches={services}
        title="Utilities and services"
        legend="Which of these additional utilities and services apply to the property?"
        description="You’ll be able to indicate who will be financially responsible in the next step"
      />
    </div>
  );
}
